<div>
  <td>
    <tr>
<nz-spin [nzSpinning]="loading">
  <nz-upload  [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload" >
    <button nz-button class="upload-button default-button" >
        <em nz-icon nzType="upload"></em>{{'UploadExcel'|translate}}
    </button>
</nz-upload>
</nz-spin>
</tr>


</td>
<td><tr>
  <nz-spin [nzSpinning]="loading">
    <div nz-col nzPush="10">
      <button nz-button nzType="primary" class="default-button"  (click)="DownloadExample()">{{'DownloadAccountInvalidityClosedExample'|translate}}</button>
    </div>
  </nz-spin>
  </tr>
</td>
</div>